import React from 'react';
import { Check, ChevronRight, X } from 'lucide-react';
import { coachSteps, notStatements, progressionStages } from '../data/offer';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-seafoam-light border-y border-seafoam/60" data-id="element-288" data-mp="1rq21cglsxzud">
      <div className="max-w-5xl mx-auto text-center" data-id="element-289" data-mp="1rrv0zbxzzjsv">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-4 text-navy" data-id="element-290" data-mp="1ms0avam1qy8v">
          Open the System. Choose the Skill. Start Coaching.
        </h2>
        <p className="text-xl text-forest font-semibold mb-2" data-id="element-291" data-mp="u2jkeihzlrfa">
          The Complete MTB Coaching System for Coaches Worldwide
        </p>
        <p className="text-base md:text-lg text-muted mb-12" data-id="element-292" data-mp="182udls6rri3m">
          <span className="font-bold text-navy" data-id="element-293" data-mp="140pkqvo5api1">MOUNTAIN BIKE COACH READY</span> · 6 Complete
          Volumes · 150 Ready-to-Coach Sessions · 5 Strategic Bonuses
        </p>

        <div className="grid md:grid-cols-2 gap-6 text-left mb-14" data-id="element-294" data-mp="2jj2ii09ob5ig">
          <div className="space-y-4 bg-white p-6 md:p-8 rounded-2xl border border-line shadow-sm" data-id="element-295" data-mp="2ff34ppfs2kss">
            {notStatements.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-296" data-mp="2gujtnis041j7">
                <X className="text-muted/70 shrink-0 mt-0.5" size={18} aria-hidden="true" data-id="element-297" data-mp="2gwwkymjnfo8x" />
                <p className="text-muted text-base" data-id="element-298" data-mp="2kx6ta5uwyqqy">{statement}</p>
              </div>)}
          </div>
          <div className="bg-forest p-6 md:p-8 rounded-2xl" data-id="element-299" data-mp="2pt46426yxeyz">
            <p className="text-white font-display font-extrabold text-2xl mb-2" data-id="element-300" data-mp="1t6iu2zcsvvfx">
              This system was built for the coach.
            </p>
            <p className="text-white/80 mb-5" data-id="element-301" data-mp="225w3js0xck0n">
              A complete professional resource designed to help you:
            </p>
            <ol className="space-y-2.5" data-id="element-302" data-mp="26xnva5vtgvsd">
              {coachSteps.map(step => <li key={step} className="flex items-center gap-3 text-white font-medium" data-id="element-303" data-mp="19hrvx0yslwvb">
                  <Check size={18} className="text-seafoam shrink-0" aria-hidden="true" data-id="element-304" data-mp="1eftd1gcnrm45" />
                  {step}
                </li>)}
            </ol>
          </div>
        </div>

        <p className="text-lg text-muted mb-5" data-id="element-305" data-mp="2csdz12fs7zk0">From...</p>
        <ol className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3 max-w-4xl mx-auto mb-8" data-id="element-306" data-mp="2crvyvuq0116t">
          {progressionStages.map((stage, index) => <li key={stage} className="flex items-center gap-2" data-id="element-307" data-mp="2mj0b4moai7xy" data-mpi={index}>
              <span className="px-4 py-2 rounded-full bg-white border border-seafoam text-forest font-semibold text-sm sm:text-base whitespace-nowrap" data-id="element-308" data-mp="1ysd381edjibe">
                {stage}
              </span>
              {index < progressionStages.length - 1 && <ChevronRight size={16} className="text-seafoam-dark" aria-hidden="true" data-id="element-309" data-mp="27um9gf2m0piz" />}
            </li>)}
        </ol>
        <p className="text-lg text-muted mb-2" data-id="element-310" data-mp="3j7y7287s0bwp">...and finally to a complete library of:</p>
        <p className="text-3xl md:text-5xl font-display font-black text-navy" data-id="element-311" data-mp="3e9559d1uq9cd">
          <span className="text-orange" data-id="element-312" data-mp="3eb7q7io5dca8">150</span> READY-TO-COACH MTB SESSIONS
        </p>
      </div>
    </section>;
}